import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import styled from "styled-components";

const ItemText = styled.span`
    margin-right: 24px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
    ${setFontVariant("input2", colorsPalettes.carbon[400])};
`;

export const KeywordListItem = ({ item, isEditable }) => {
    return (
        <ItemText
            contentEditable={isEditable}
            suppressContentEditableWarning={true}
        >
            {item.text.toLowerCase()}
        </ItemText>
    );
};
